import {api} from 'api';
import axios from 'axios';
import {Msg} from 'components/notifications/NotificationContext';
import {useModal} from 'hooks/useModal';
import {useCallback, useState} from 'react';
import {FileData} from 'types';
import {buildPath} from 'utils';

export const useMove = (selected: FileData[], refetchFolder: () => void) => {
   const {open: moveOpened, handleOpen: openMove, handleClose: closeMove} = useModal();

   const [item, setItem] = useState<FileData | null>();

   const moveSelected = useCallback(() => {
      setItem(selected[0]);
      openMove();
   }, [selected, openMove]);

   const moveItem = useCallback(
      (file: FileData) => {
         setItem(file);
         openMove();
      },
      [selected, openMove]
   );

   const move = useCallback(
      async (toPath: string, from?: FileData) => {
         try {
            const i = from || item;
            await axios.put(`${api.rename}`, {
               from: i?.path,
               to: buildPath(toPath, i!.name),
            });
            Msg.notify(`"${i!.name}" has been moved to "${toPath}".`, 'success');

            setItem(null);
            refetchFolder();
         } catch (e) {
            console.debug('move error ', e);
            Msg.notify('Failed to move: ' + (e as Error).message, 'error');
         }
      },
      [item, setItem, refetchFolder]
   );

   return {
      currentMovePath: item?.path,
      moveSelected,
      moveItem,
      move,
      moveOpened,
      closeMove,
   };
};
